import { render, staticRenderFns } from "./modal-benefits.vue?vue&type=template&id=09c46ff8&"
import script from "./modal-benefits.vue?vue&type=script&lang=js&"
export * from "./modal-benefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BenefitsModal: require('/var/www/components/benefits/benefits-modal.vue').default})
